/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { ReactNode } from "react";

import { isSafari } from "../../../util/platform";
import { NavItem, NavItemModel } from "../NavItem";

import styles from "./SidebarNav.module.scss";

export type SidebarNavProps = {
  logo: ReactNode;
  items: NavItemModel[];
  testId?: string;
  onLogoClick?: () => void;
};

export const SidebarNav = ({ logo, items, testId, onLogoClick }: SidebarNavProps) => (
  <nav
    aria-label={"Primary"}
    data-testid={testId}
    className={`
      fixed top-(--sidenav-inset) bottom-(--sidenav-inset) left-(--sidenav-inset) z-[1100]
      w-(--sidenav-width) overflow-hidden rounded-lg bg-forest-green-950
    `}
  >
    <div
      className={`
        native-scrollbar flex h-full w-full flex-col items-center gap-6 overflow-x-hidden
        overflow-y-auto px-1 py-4
        ${isSafari() ? "" : styles.flSidebarNav__scrollbar}
      `}
    >
      <div className="flex w-24 justify-center p-4" onClick={onLogoClick}>
        {logo}
      </div>
      <ul className="flex w-full flex-col gap-6">
        {items.map((item) => (
          <NavItem key={item.id} size="lg" {...item} />
        ))}
      </ul>
    </div>
  </nav>
);
